import React, { useEffect, useState, useMemo } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import RequestService from '../../services/RequestService'
import { useFieldArray, useForm } from "react-hook-form";
import SgsService from '../../services/SgsService';
import { CiCircleInfo } from "react-icons/ci";
import DepositService from '../../services/DepositService'
import GmoService from "../../services/GmoService";
import "react-toastify/dist/ReactToastify.css";
import TiposBoleto from "../../enums/TiposBoleto";
import TiposPlanta from "../../enums/TiposPlanta";
import TiposAtendimento from './../../enums/TiposAtendimento';
import { atendimentosPermitidos, atendimentoValido } from './../../enums/TipoAtendimentoPorBoleto';
import CompanyService from "../../services/CompanyService"
import CodBloqueadosService from "../../services/CodBloqueadosService";
import moment from "moment-timezone"
import { ehUsuarioInterno } from "../../utils/roles";

const MAX_EQUIPMENT_ITEMS = 4;
const MAX_TOTAL_EQUIPMENT_QUANTITY = 4;

const createEmptyEquipment = () => ({
  codSap: "",
  nomeEquipamento: "",
  fabricanteEquipamento: "",
  partNumberEquipamento: "",
  familiaEquipamento: "",
  grupoProdutoEquipamento: "",
  quantidade: 1,
});

export default function NewRequestModal({ isModalOpen, setModalOpen, user }) {
  // Estado para exibir/ocultar campo BBN Aberto Em
  const [showBbnAbertoEm, setShowBbnAbertoEm] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    trigger,
    watch,
    formState: { errors },
  } = useForm({defaultValues: {
    // reLegalSolicitante: user?.reLegal,
    // nomeSolicitante: user?.name,
    // uf: "SP - SÃO PAULO",
    // respUsuario: "TELEFONICA BRASIL S.A.",
    // codSap: "0375-4696-1",
    // codSap2: "P-8Q00 013 230",
    // equipamento: "CX NEAX SIGMA",
    // respSap: "LOGICTEL",
    // quantidade: 1,
    // idBoleto: "23345678",
    // tipoBoleto: "ta-ticket-anormalidade-geral",
    // tipoAtendimento: "vital",
    // site: "SPO.IP",
    // gmo: "GMO - SP - IPIRANGA",
    // fct: "2132 - RUA XAVIER CURADO NRO 473 - IPIRANGA - 04210-100",
    // telefone: "(11) 99988-9999",
    // enderecoEntrega: "RUA XAVIER CURADO, 473",
    // enderecoEntregaComplemento: "6º andar",
    observacao: "",
    comentarioGestao: "",
    isFurtoVandalismo: false,
    qtdFurtoVandalismo: "",
    isMultipleEquipamentos: false,
    quantidadeEquipamentos: 1,
    equipamentos: [createEmptyEquipment()],
  }});

  const { fields: equipmentFields, replace: replaceEquipmentFields } = useFieldArray({
    control,
    name: "equipamentos",
  });

  const [searchResults, setSearchResults] = useState({});
  const [showDevicesList, setShowDevicesList] = useState({})
  const [depositList, setDepositList] = useState([]);
  const [gmoList, setGmoList] = useState([]);
  const [isProgramado, setIsProgramado] = useState(false)

  const [companyList, setCompanyList] = useState([]);

  const [isReplica, setIsReplica] = useState(false);
  // const [createReverse, setCreateReverse] = useState(false);

  const [selectedEnderecoEntrega, setSelectedEnderecoEntrega] = useState("");

  const [gmoSearchTerm, setGmoSearchTerm] = useState("");
  const [gmoSearchResults, setGmoSearchResults] = useState([]);
  const [showGmoList, setShowGmoList] = useState(false);

  const [enderecoEntregaSearchTerm, setEnderecoEntregaSearchTerm] = useState("");
  const [enderecoEntregaSearchResults, setEnderecoEntregaSearchResults] = useState([]);
  const [showEnderecoEntregaList, setShowEnderecoEntregaList] = useState(false);

  const [gmoDisabled, setGmoDisabled] = useState(true);
  const tipoAtendimento = watch("tipoAtendimento");
  const tipoBoleto = watch("tipoBoleto");
  const isFurtoVandalismo = watch("isFurtoVandalismo");
  const qtdFurtoVandalismo = watch("qtdFurtoVandalismo");
  const isMultipleEquipamentos = watch("isMultipleEquipamentos");
  const quantidadeEquipamentos = watch("quantidadeEquipamentos");
  const watchedEquipamentos = watch("equipamentos");
  const [codigosBloqueados, setCodigosBloqueados] = useState({});
  const hasBlockedCodSap = Object.values(codigosBloqueados).some(Boolean);
  const canSelectMultipleEquipamentos = ehUsuarioInterno(user) && ['bbn-dwdm-fspo', 'bbn-dwdm-dspo'].includes(tipoBoleto);

  const getTotalRequestedQuantity = (equipamentos = []) => {
    return equipamentos.reduce((total, equipamento) => {
      return total + (Number(equipamento?.quantidade) || 0);
    }, 0);
  };

  // Forçar atualização do campo BBN Aberto Em ao mudar tipoAtendimento
  useEffect(() => {
    // Se mudar o tipo de atendimento para algo diferente, reseta o checkbox
    setShowBbnAbertoEm(false);
  }, [tipoAtendimento]);

  useEffect(() => {
    if (canSelectMultipleEquipamentos) {
      return;
    }

    if (getValues("quantidadeEquipamentos") !== 1) {
      setValue("quantidadeEquipamentos", 1);
    }

    if (getValues("isMultipleEquipamentos")) {
      setValue("isMultipleEquipamentos", false);
    }
  }, [canSelectMultipleEquipamentos, getValues, setValue]);

  useEffect(() => {
    if (isFurtoVandalismo) {
      if (!getValues("qtdFurtoVandalismo")) {
        setValue("qtdFurtoVandalismo", 1);
      }
      return;
    }

    if (getValues("qtdFurtoVandalismo")) {
      setValue("qtdFurtoVandalismo", "");
    }
  }, [getValues, isFurtoVandalismo, setValue]);


  useEffect(() => {
    const requestedQuantity = isMultipleEquipamentos ? Number(quantidadeEquipamentos) || 1 : 1;
    const nextQuantity = Math.min(MAX_EQUIPMENT_ITEMS, Math.max(1, requestedQuantity));

    if (!isMultipleEquipamentos && getValues("quantidadeEquipamentos") !== 1) {
      setValue("quantidadeEquipamentos", 1);
    }

    if (isMultipleEquipamentos && requestedQuantity > MAX_EQUIPMENT_ITEMS) {
      setValue("quantidadeEquipamentos", MAX_EQUIPMENT_ITEMS);
    }

    if (equipmentFields.length !== nextQuantity) {
      const currentEquipments = getValues("equipamentos") || [];
      replaceEquipmentFields(
        Array.from({ length: nextQuantity }, (_, index) => {
          return currentEquipments[index] || createEmptyEquipment();
        })
      );

      setSearchResults((prev) => {
        const next = {};
        for (let index = 0; index < nextQuantity; index += 1) {
          if (prev[index]) next[index] = prev[index];
        }
        return next;
      });

      setShowDevicesList((prev) => {
        const next = {};
        for (let index = 0; index < nextQuantity; index += 1) {
          if (prev[index]) next[index] = prev[index];
        }
        return next;
      });

      setCodigosBloqueados((prev) => {
        const next = {};
        for (let index = 0; index < nextQuantity; index += 1) {
          if (prev[index]) next[index] = prev[index];
        }
        return next;
      });
    }
  }, [equipmentFields.length, getValues, isMultipleEquipamentos, quantidadeEquipamentos, replaceEquipmentFields, setValue]);

  useEffect(() => {
    if (!watchedEquipamentos?.length) {
      return;
    }

    trigger(watchedEquipamentos.map((_, index) => `equipamentos.${index}.quantidade`));

    if (isFurtoVandalismo || qtdFurtoVandalismo) {
      trigger("qtdFurtoVandalismo");
    }
  }, [isFurtoVandalismo, qtdFurtoVandalismo, trigger, watchedEquipamentos]);

  const handleInputChange = async (index, e) => {
    setShowDevicesList((prev) => ({ ...prev, [index]: true }));
    const searchTerm = e.target.value;
    if (searchTerm.length >= 3) {
      try {
        const data = await SgsService.getSgsItems(`?name=${searchTerm}`);
        setSearchResults((prev) => ({
          ...prev,
          [index]: data.result.data,
        }));
        // console.log(data.result.data)
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    } else {
      setSearchResults((prev) => ({ ...prev, [index]: [] }));
    }
  };

  const handleSelectItem = async (index, item) => {
    let isBlocked = false;
  
    // Valida se o código está bloqueado. A verificação é exata no backend (busca
    // por codSap indexado), então não precisa mais filtrar a lista aqui.
    try {
      const response = await CodBloqueadosService.verificarBloqueio(item.codigo);
      isBlocked = Boolean(response?.bloqueado);
    } catch (error) {
      console.error('Erro ao verificar código bloqueado:', error);
    }

    setCodigosBloqueados((prev) => ({
      ...prev,
      [index]: isBlocked,
    }));
  
    // Atualiza os valores do formulário
    setValue(`equipamentos.${index}.codSap`, item.codigo, { shouldValidate: true });
    setValue(`equipamentos.${index}.nomeEquipamento`, item.nome, { shouldValidate: true });
    setValue(`equipamentos.${index}.partNumberEquipamento`, item.partNumberComum, { shouldValidate: true });
    setValue(`equipamentos.${index}.fabricanteEquipamento`, item.nomeFabricante, { shouldValidate: true });
    setValue(`equipamentos.${index}.familiaEquipamento`, item.nomeFamilia, { shouldValidate: true });
    setValue(`equipamentos.${index}.grupoProdutoEquipamento`, item.nomeGrupoProduto, { shouldValidate: true });
  
    setShowDevicesList((prev) => ({ ...prev, [index]: false }));
    setSearchResults((prev) => ({ ...prev, [index]: [] }));
  };

   const onSubmit = async (data) => {
      const equipamentos = (data.equipamentos || []).map((equipamento) => ({
        ...equipamento,
        quantidade: Number(equipamento.quantidade),
      }));

      if (equipamentos.length > MAX_EQUIPMENT_ITEMS) {
        toast.error(`O limite de equipamentos por solicitação é ${MAX_EQUIPMENT_ITEMS}.`);
        return;
      }

      const quantidadeTotal = getTotalRequestedQuantity(equipamentos);

      // O limite total só se aplica em modo equipamento múltiplo. Equipamento único
      // pode ter qualquer quantidade.
      if (data.isMultipleEquipamentos && quantidadeTotal > MAX_TOTAL_EQUIPMENT_QUANTITY) {
        toast.error(`A soma das quantidades dos equipamentos deve ser no máximo ${MAX_TOTAL_EQUIPMENT_QUANTITY}.`);
        return;
      }

      const equipamentoPrincipal = equipamentos[0] || createEmptyEquipment();

      const payload = {
        ...data,
        equipamentos,
        codSap: equipamentoPrincipal.codSap,
        nomeEquipamento: equipamentoPrincipal.nomeEquipamento,
        fabricanteEquipamento: equipamentoPrincipal.fabricanteEquipamento,
        partNumberEquipamento: equipamentoPrincipal.partNumberEquipamento,
        familiaEquipamento: equipamentoPrincipal.familiaEquipamento,
        grupoProdutoEquipamento: equipamentoPrincipal.grupoProdutoEquipamento,
        quantidade: quantidadeTotal || Number(equipamentoPrincipal.quantidade) || 1,
      };

      // setDeadline(Date.now());
      // setIsLoading(true)
      // const body = { data }

      const response =  await RequestService.createRequest(payload);
      // const response =  true;
      
      if (response) {
          toast.success('Solicitação criada!');
          // console.log(data)
      } else {
        // console.log(error)
        toast.error("Ops! Algo deu errado");
      }

      // setIsLoading(false)
      // setDeadline(null);

      setModalOpen(!isModalOpen);
      setIsProgramado(false)
      setIsReplica(false)
      setSelectedEnderecoEntrega(""); // Limpa seleção do endereço de entrega
      setEnderecoEntregaSearchTerm(""); // Limpa busca do endereço de entrega
      setEnderecoEntregaSearchResults([]); // Limpa resultados da busca do endereço de entrega
      setShowEnderecoEntregaList(false); // Fecha lista de endereços de entrega
      setGmoSearchTerm(""); // Limpa busca de GMO
      setGmoSearchResults([]); // Limpa resultados da busca de GMO
      setShowGmoList(false); // Fecha lista de GMO
      setSearchResults({}); // Limpa resultados de equipamentos
      setShowDevicesList({}); // Fecha lista de equipamentos
      setCodigosBloqueados({});
      reset();

  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    setIsProgramado(false)
    setIsReplica(false)
    // setCreateReverse(false)
    setSelectedEnderecoEntrega(""); // Limpa seleção do endereço de entrega
    setEnderecoEntregaSearchTerm(""); // Limpa busca do endereço de entrega
    setEnderecoEntregaSearchResults([]); // Limpa resultados da busca do endereço de entrega
    setShowEnderecoEntregaList(false); // Fecha lista de endereços de entrega
    setGmoSearchTerm(""); // Limpa busca de GMO
    setGmoSearchResults([]); // Limpa resultados da busca de GMO
    setShowGmoList(false); // Fecha lista de GMO
    setSearchResults({}); // Limpa resultados de equipamentos
    setShowDevicesList({}); // Fecha lista de equipamentos
    setCodigosBloqueados({});
    reset();
  };

  // const handleOnGmoChange = async (e) => {
  //   const gmoId = e.target.value
  //   const gmo = await GmoService.getGmoById(gmoId); 
  //   // console.log(gmo)

  //   setValue("drsOriginal", gmo.gmo.depositoOrigem._id)
  //   setValue("enderecoDepostio", gmo.gmo.depositoOrigem.endereco)
  //   setValue("enderecoEntrega", gmo.gmo.endereco)
  // }

  const handleOnGmoChange = async (e) => {
    const gmoId = e.target.value;
    const gmo = await GmoService.getGmoById(gmoId);

    setValue("drsOriginal", gmo.gmo.depositoOrigem._id);
    setValue("enderecoDepostio", gmo.gmo.depositoOrigem.endereco);
    setValue("enderecoEntrega", gmo.gmo.endereco);
    setValue("cidadeEntrega", gmo.gmo.cidade);

    setSelectedEnderecoEntrega(gmo.gmo._id); // Atualiza o select do endereço de entrega
  };

  useEffect(()=>{

    const fetchData = async () =>{
      const deposits = await DepositService.getDeposits();
      // const gmos = await GmoService.getGmos();
      const companies = await CompanyService.getCompanies();    
      
      setDepositList(deposits);
      // setGmoList(gmos)
      setCompanyList(companies.companies);
    }
    fetchData();

    // console.log(user)
    setValue("reLegalSolicitante", user?.reLegal)
    setValue("nomeSolicitante", user?.name)
    setValue("uf", user?.uf)
    setValue("respUsuario", user?.respUsuario?.toUpperCase())
    // setValue("tecnico", user?.name)
    setValue("reTecnico", user?.reLegal)
    setValue("empresaTecnico", user?.company?._id)
    // setValue("telefone", user?.phone)

  }, [isModalOpen, setValue, user]);

  useEffect(() => {
    if (!tipoAtendimento || tipoAtendimento === "0") {
      setGmoDisabled(true);
      setGmoList({ gmos: [] });
      setGmoSearchTerm("");
      setGmoSearchResults([]);
      setValue("gmo", "");
      return;
    }
    setGmoDisabled(false);

    const fetchGmos = async () => {
      let filter = "";
      if (tipoAtendimento === "bbn-alta" || tipoAtendimento === "bbn-media") {
        filter = "?isBbn=true";
      } else {
        filter = "?isBbn=false";
      }
      const gmos = await GmoService.getGmos(filter);
      setGmoList(gmos);
    };

    fetchGmos();
  }, [tipoAtendimento, setValue]);

  // BBN Alta/Média só existem para o boleto BBN - DWDM FSPO; todos os demais
  // boletos usam Vital/Programado. Antes o caso default devolvia a lista
  // inteira, então um boleto comum ainda oferecia os atendimentos BBN.
  const tiposAtendimentoFiltrados = useMemo(() => {
    const permitidos = atendimentosPermitidos(tipoBoleto);
    return TiposAtendimento.filter((t) => permitidos.includes(t.cod));
  }, [tipoBoleto]);

  // Trocar o boleto pode invalidar o atendimento já escolhido — o valor ficava
  // no formulário mesmo sem existir mais como opção no select, e era enviado
  // assim no submit. Limpa para o usuário escolher de novo.
  useEffect(() => {
    if (!atendimentoValido(tipoBoleto, tipoAtendimento)) {
      setValue("tipoAtendimento", "0", { shouldValidate: false });
    }
  }, [tipoBoleto, tipoAtendimento, setValue]);

  const handleTipoAtendimento = (event) => {
    // console.log(event.target.value)
    if (event.target.value === 'programado'){ 
      setIsProgramado(true) 
    } else {
      setIsProgramado(false) 
    }

  }

  const handleSetIsReplica = (event) => {
    setIsReplica(event.target.checked);
    setValue("isReplica", event.target.checked);
    // console.log(event.target.checked)
  };

  const handleChangeEnderecoEntrega = (e) => {
    const gmoId = e.target.value;
    const gmo = gmoList.gmos.find((g) => g._id === gmoId);
    if (gmo) {
      setValue("enderecoEntrega", gmo.endereco);
      setValue("cidadeEntrega", gmo.cidade);
      setSelectedEnderecoEntrega(gmo._id);
    } else {
      setValue("enderecoEntrega", "");
      setValue("cidadeEntrega", "");
      setSelectedEnderecoEntrega("");
    }
  };

  // Função para buscar GMOs conforme o termo digitado
  const handleGmoInputChange = (e) => {
    const value = e.target.value;
    setGmoSearchTerm(value);
    setShowGmoList(true);

    if (value.length >= 3) {
      // Filtra localmente, mas pode ser adaptado para buscar via API se necessário
      const filtered = gmoList.gmos.filter(gmo =>
        (gmo.cidade + " " + gmo.identificador + " " + gmo.endereco)
          .toLowerCase()
          .includes(value.toLowerCase())
      );
      setGmoSearchResults(filtered);
    } else {
      setGmoSearchResults([]);
    }
  };

  // Ao selecionar um GMO da lista
  const handleSelectGmo = async (gmo) => {
    setValue("gmo", gmo._id, { shouldValidate: true });
    setGmoSearchTerm(
      gmo.cidade === "SÃO PAULO"
        ? `SP - ${gmo.identificador} - ${gmo.endereco}`
        : `${gmo.cidade} - ${gmo.endereco}`
    );
    setShowGmoList(false);

    // Mantém o comportamento de setar endereço de entrega
    setValue("drsOriginal", gmo.depositoOrigem?._id);
    setValue("enderecoDepostio", gmo.depositoOrigem?.endereco);
    setValue("enderecoEntrega", gmo.endereco);
    setValue("cidadeEntrega", gmo.cidade);
    setSelectedEnderecoEntrega(gmo._id);
  };

  // Função para buscar endereços de entrega conforme o termo digitado
const handleEnderecoEntregaInputChange = (e) => {
  const value = e.target.value;
  setEnderecoEntregaSearchTerm(value);
  setShowEnderecoEntregaList(true);

  if (value.length >= 3) {
    const filtered = gmoList.gmos.filter(gmo =>
      (gmo.cidade + " " + gmo.identificador + " " + gmo.endereco)
        .toLowerCase()
        .includes(value.toLowerCase())
    );
    setEnderecoEntregaSearchResults(filtered);
  } else {
    setEnderecoEntregaSearchResults([]);
  }
};

// Ao selecionar um endereço de entrega da lista
const handleSelectEnderecoEntrega = (gmo) => {
  setSelectedEnderecoEntrega(gmo._id);
  setEnderecoEntregaSearchTerm(
    gmo.cidade === "SÃO PAULO"
      ? `SP - ${gmo.identificador} - ${gmo.endereco}`
      : `${gmo.cidade} - ${gmo.endereco}`
  );
  setShowEnderecoEntregaList(false);

  setValue("enderecoEntrega", gmo.endereco);
  setValue("cidadeEntrega", gmo.cidade);
};

  // const handleSetCreateReverse = (event) => {
  //   setCreateReverse(event.target.checked);
  //   setValue("createReverse", event.target.checked);
  //   // console.log(event.target.checked)
  // };

  // Obtém a data e hora atual no formato YYYY-MM-DDTHH:MM

  const minDateTime = moment().tz('America/Sao_Paulo').format('YYYY-MM-DDTHH:mm');

  // Mínimo permitido para "Programar para": início do dia seguinte (D+1).
  // Usado tanto no attr `min` (bloqueia o calendário) quanto no validate do
  // react-hook-form (pega quem digita manualmente).
  const minDateProgramado = moment().tz('America/Sao_Paulo').add(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm');

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[800px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-6" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex justify-between items-center ps-6 pe-20 text-left gap-4 bg-gray-800 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4 mb-2">
                  NOVA SOLICITAÇÃO
                </div>
                {/* Checkbox para replicados do SGRS */}
                {ehUsuarioInterno(user) &&
                  <div className="flex items-center gap-2">
                    <label className="text-white whitespace-nowrap">
                      Réplica SGRS
                    </label>
                    <input
                      id="isReplica"
                      type="checkbox"
                      checked={isReplica}
                      onChange={handleSetIsReplica}
                      className="form-checkbox h-4 w-4 text-blue-600"
                    />
                  </div>
                }
                <div className="flex items-center gap-2">
                  <label className="text-white whitespace-nowrap">
                    Furto/Vandalismo?
                  </label>
                  <input
                    id="isFurtoVandalismo"
                    type="checkbox"
                    {...register("isFurtoVandalismo")}
                    className="form-checkbox h-4 w-4 text-blue-600"
                  />
                  <input
                    type="number"
                    min="1"
                    disabled={!isFurtoVandalismo}
                    {...register("qtdFurtoVandalismo", {
                      valueAsNumber: true,
                      validate: (value) => {
                        if (!isFurtoVandalismo) {
                          return true;
                        }

                        if (!value || value < 1) {
                          return "Informe uma quantidade valida";
                        }

                        const quantidadeTotalSolicitada = getTotalRequestedQuantity(getValues("equipamentos") || []);

                        if (value > quantidadeTotalSolicitada) {
                          return `A quantidade de Furto/Vandalismo nao pode ser maior que a quantidade solicitada total (${quantidadeTotalSolicitada}).`;
                        }

                        return true;
                      },
                    })}
                    className={`block w-16 rounded-2xl px-3 text-gray-900 shadow-sm placeholder:text-gray-400 text-sm
                      ${errors?.qtdFurtoVandalismo ? " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"}
                    `}
                  />
                </div>             
              </div>
              {errors?.qtdFurtoVandalismo && (
                <p className="px-6 pt-1 text-red-500 text-xs">
                  {errors.qtdFurtoVandalismo.message}
                </p>
              )}

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-6">
                <div className="w-full relative inline-block text-left">
                  <div className="flex justify-start items-center">

                    <div className="w-full flex flex-col text-xs gap-2">

                      {/* Div número do SGRS caso seja chamado réplicado */}
                      { isReplica && 
                      <div className="flex flex-col px-4 py-2 gap-2 bg-gray-50 border rounded-md relative">
                        <div className="flex flex-row gap-2 w-full">

                            <div className="flex flex-row items-center gap-2 w-full">
                              <label className="block text-gray-700 font-bold whitespace-nowrap">Número SGRS:</label>
                              <input
                                type="text"
                                {...register("sgrsNumber", {
                                  required: isReplica,
                                  validate: (value) => value.length === 11 || "Número SGRS deve ter 11 dígitos"
                                })}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos
                                  if (value.length <= 11) {
                                    e.target.value = value;
                                  }
                                }}
                                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
      ${errors?.sgrsNumber ? "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"}
    `}
                              />
                              {errors?.sgrsNumber && (
                                <p className="text-red-500 text-xs ms-2">
                                  {errors.sgrsNumber.message || "Campo obrigatório"}
                                </p>
                              )}
                            </div>

                            <div className="flex flex-row items-center gap-2 w-full">
                              <label className="block text-gray-700 font-bold whitespace-nowrap">
                                Aberto em:
                              </label>
                              <input
                                {...register("sgrsAbertoEm", { required: isProgramado ? true : false })}
                                // disabled={!isProgramado ? true : false}
                                max={minDateTime}
                                type="datetime-local"
                                placeholder="Start Date and Time"
                                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${errors?.sgrsAbertoEm?.type === "required"
                                    ? " border border-red-500 outline-none ring-0"
                                    : "border border-zinc-500 outline-none ring-0"
                                  }
                              `}
                              />
                              {errors?.sgrsAbertoEm?.type === "required" && (
                                <p className="text-red-500 text-xs ms-2">
                                  Campo obrigatório
                                </p>
                              )}
                            </div>

                            {/* <div className="flex items-center gap-2">
                              <label className="whitespace-nowrap">
                                Gerar Reversa
                              </label>
                              <input
                                id="createReverse"
                                type="checkbox"
                                checked={createReverse}
                                onChange={handleSetCreateReverse}
                                className="form-checkbox h-4 w-4 text-blue-600"
                              />
                            </div> */}

                        </div>  
                      </div>
                      }

                      {/* Trecho para BBN Aberto Em */}
                      {(
                        ['bbn-alta', 'bbn-media'].includes(tipoAtendimento) ||
                        tipoBoleto === 'bbn-dwdm-fspo'
                      ) && (
                          <div className="flex flex-col px-4 py-2 gap-2 bg-gray-50 border rounded-md relative mt-2">
                            <div className="flex flex-row items-center gap-2 w-full">
                              <input
                              id="showBbnAbertoEm"
                              type="checkbox"
                              checked={showBbnAbertoEm}
                              onChange={e => setShowBbnAbertoEm(e.target.checked)}
                              className="form-checkbox h-4 w-4 text-blue-600"
                            />
                            <label htmlFor="showBbnAbertoEm" className="block text-gray-700 font-bold whitespace-nowrap">
                              Alterar data/hora de abertura
                            </label>
                          </div>
                          {showBbnAbertoEm && (
                            <div className="flex flex-row items-center gap-2 w-full mt-2">
                              <label className="block text-gray-700 font-bold whitespace-nowrap">
                                BBN aberto em:
                              </label>
                              <input
                                {...register("bbnAbertoEm", { required: showBbnAbertoEm })}
                                max={minDateTime}
                                type="datetime-local"
                                placeholder="Start Date and Time"
                                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                  ${errors?.bbnAbertoEm?.type === "required"
                                    ? " border border-red-500 outline-none ring-0"
                                    : "border border-zinc-500 outline-none ring-0"
                                  }
                                `}
                              />
                              {errors?.bbnAbertoEm?.type === "required" && (
                                <p className="text-red-500 text-xs ms-2">
                                  Campo obrigatório
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      )}

                      {/* DIV Usuario */}
                      <div className="flex flex-col px-4 py-2 gap-2 bg-gray-50 border rounded-md relative">
                        {/* <div className="absolute right-4 top-2 text-blue-400 font-bold"><a href="#">Ver mais</a></div> */}
                        <div className="flex flex-row gap-2 w-full">
                          <div className="flex flex-col items-start gap-1 w-1/3">
                            <label className="block text-gray-700 font-bold">RE/Legal Solicitante:</label>
                            <input
                              disabled={true}
                              type="text"
                              {...register("reLegalSolicitante", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.reLegalSolicitante?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.reLegalSolicitante?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Nome Solicitante:</label>
                            <input
                              disabled={true}
                              type="text"                              
                              {...register("nomeSolicitante", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.nomeSolicitante?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.nomeSolicitante?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>
                          <div className="flex flex-col items-start gap-1 w-1/5">
                              <label className="block text-gray-700 font-bold">UF:</label>
                            <div className="block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm border border-zinc-500 outline-none ring-0">
                              {user?.uf}
                            </div>
                            </div>
                        </div>
                        
                        <div className="flex justify-center items-center gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Empresa:</label>
                          <div className="block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm border border-zinc-500 outline-none ring-0">
                            {user?.company?.name}
                          </div>
                        </div>
                        
                      </div>

                      {/* div Cod SAP / Equipamento */}
                      <div className="flex flex-col gap-3 px-4 py-2 bg-gray-50 border rounded-md relative">
                      {/* <div className="absolute right-4 top-2 text-blue-400 font-bold flex gap-8"><a href="#">Pesquisar</a><a href="#">Ver mais</a></div> */}
                        {canSelectMultipleEquipamentos &&
                        <div className="flex flex-wrap items-end justify-start gap-3">          
                            <div className="flex items-center gap-2">
                              <label className="text-gray-700 font-bold whitespace-nowrap">
                                Múltiplos
                              </label>
                              <input
                                type="checkbox"
                                {...register("isMultipleEquipamentos")}
                                className="form-checkbox h-4 w-4 text-blue-600"
                              />
                            </div>
                          

                          <div className="flex flex-col items-start gap-1 w-32">
                            {/* <label className="block text-gray-700 font-bold whitespace-nowrap">Quantidade:</label> */}
                            <input
                              type="number"
                              min="1"
                              max={MAX_EQUIPMENT_ITEMS}
                              disabled={!isMultipleEquipamentos}
                              {...register("quantidadeEquipamentos", {
                                valueAsNumber: true,
                                validate: (value) => {
                                  if (!isMultipleEquipamentos) {
                                    return true;
                                  }

                                  if (value < 1) {
                                    return "Informe ao menos 1 item";
                                  }

                                  if (value > MAX_EQUIPMENT_ITEMS) {
                                    return `Limite de ${MAX_EQUIPMENT_ITEMS} equipamentos`;
                                  }

                                  return true;
                                },
                              })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.quantidadeEquipamentos?.type === "validate"
                                    ? " border border-red-500 outline-none ring-0"
                                    : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.quantidadeEquipamentos?.type === "validate" && (
                              <p className="text-red-500 text-xs ms-2">
                                {errors?.quantidadeEquipamentos?.message}
                              </p>
                            )}
                          </div>
                        </div>
                        }

                        {equipmentFields.map((field, index) => (
                          <div key={field.id} className="flex flex-col gap-2 rounded-md border border-zinc-200 bg-white p-3">
                            {isMultipleEquipamentos && (
                              <div className="text-xs font-bold text-gray-600">
                                Equipamento {index + 1}
                              </div>
                            )}

                            <div className="flex flex-row items-end gap-2 w-full">
                              <div className="flex flex-col items-start gap-1 flex-[2.4] relative">
                                <label className="block text-gray-700 font-bold whitespace-nowrap">Buscar (nome, código SAP ou part number):</label>
                                <input
                                  type="text"
                                  {...register(`equipamentos.${index}.nomeEquipamento`, {
                                    onChange: (event) => handleInputChange(index, event),
                                  })}
                                  placeholder="...digite ao menos 3 caracteres para buscar"
                                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                    ${
                                      errors?.equipamentos?.[index]?.nomeEquipamento?.type === "required"
                                        ? " border border-red-500 outline-none ring-0"
                                        : "border border-zinc-500 outline-none ring-0"
                                    }
                                  `}
                                />
                                {searchResults[index]?.length > 0 && showDevicesList[index] && (
                                  <div className="absolute w-full top-full left-0 mt-1 max-h-52 overflow-y-auto bg-white rounded shadow-lg border border-gray-200 z-20">
                                    <ul>
                                      {searchResults[index].map((item) => (
                                        <li key={`${item.codigo}-${index}`} onClick={() => handleSelectItem(index, item)} className="px-4 py-2 cursor-pointer hover:bg-gray-100">
                                          {item.nome}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>

                              <div className="flex flex-col items-start gap-1 w-28 shrink-0">
                                <label className="block text-gray-700 font-bold whitespace-nowrap">Cód SAP:</label>
                                <input
                                  disabled={true}
                                  type="text"
                                  {...register(`equipamentos.${index}.codSap`, { required: true })}
                                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                    ${
                                      errors?.equipamentos?.[index]?.codSap?.type === "required"
                                        ? " border border-red-500 outline-none ring-0"
                                        : "border border-zinc-500 outline-none ring-0"
                                    }
                                  `}
                                />
                                {errors?.equipamentos?.[index]?.codSap?.type === "required" && (
                                  <p className="text-red-500 text-xs ms-2">
                                    Campo obrigatório
                                  </p>
                                )}
                              </div>

                              <div className="flex flex-col items-start gap-1 flex-1 min-w-0">
                                <label className="block text-gray-700 font-bold whitespace-nowrap">Fabricante:</label>
                                <input
                                  disabled={true}
                                  type="text"
                                  {...register(`equipamentos.${index}.fabricanteEquipamento`, { required: true })}
                                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                    ${
                                      errors?.equipamentos?.[index]?.fabricanteEquipamento?.type === "required"
                                        ? " border border-red-500 outline-none ring-0"
                                        : "border border-zinc-500 outline-none ring-0"
                                    }
                                  `}
                                />
                                {errors?.equipamentos?.[index]?.fabricanteEquipamento?.type === "required" && (
                                  <p className="text-red-500 text-xs ms-2">
                                    Campo obrigatório
                                  </p>
                                )}
                              </div>

                              <div className="flex flex-col items-start gap-1 flex-1 min-w-0">
                                <label className="block text-gray-700 font-bold whitespace-nowrap">Part Number:</label>
                                <input
                                  disabled={true}
                                  type="text"
                                  {...register(`equipamentos.${index}.partNumberEquipamento`, { required: true })}
                                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                    ${
                                      errors?.equipamentos?.[index]?.partNumberEquipamento?.type === "required"
                                        ? " border border-red-500 outline-none ring-0"
                                        : "border border-zinc-500 outline-none ring-0"
                                    }
                                  `}
                                />
                                {errors?.equipamentos?.[index]?.partNumberEquipamento?.type === "required" && (
                                  <p className="text-red-500 text-xs ms-2">
                                    Campo obrigatório
                                  </p>
                                )}
                              </div>

                              <div className="flex flex-col items-start gap-1 w-24 shrink-0">
                                <label className="block text-gray-700 font-bold whitespace-nowrap">Qtdade Solicitada:</label>
                                <input
                                  type="number"
                                  min="1"
                                  max={isMultipleEquipamentos ? MAX_TOTAL_EQUIPMENT_QUANTITY : undefined}
                                  {...register(`equipamentos.${index}.quantidade`, {
                                    required: "Campo obrigatório",
                                    valueAsNumber: true,
                                    validate: (value) => {
                                      if (value <= 0) {
                                        return "Deve ser maior que zero";
                                      }

                                      // Sem equipamento múltiplo, não há limite total — qualquer quantidade é permitida.
                                      if (!isMultipleEquipamentos) {
                                        return true;
                                      }

                                      const equipamentos = getValues("equipamentos") || [];
                                      const equipamentosAtualizados = equipamentos.map((equipamento, equipmentIndex) => {
                                        if (equipmentIndex !== index) {
                                          return equipamento;
                                        }

                                        return {
                                          ...equipamento,
                                          quantidade: Number(value) || 0,
                                        };
                                      });

                                      return getTotalRequestedQuantity(equipamentosAtualizados) <= MAX_TOTAL_EQUIPMENT_QUANTITY
                                        || `A soma das quantidades deve ser no máximo ${MAX_TOTAL_EQUIPMENT_QUANTITY}`;
                                    },
                                  })}
                                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                    ${
                                      errors?.equipamentos?.[index]?.quantidade
                                        ? " border border-red-500 outline-none ring-0"
                                        : "border border-zinc-500 outline-none ring-0"
                                    }
                                  `}
                                />
                                {errors?.equipamentos?.[index]?.quantidade && (
                                  <p className="text-red-500 text-xs ms-2">
                                    {errors?.equipamentos?.[index]?.quantidade?.message}
                                  </p>
                                )}
                              </div>
                            </div>

                            <input type="hidden" {...register(`equipamentos.${index}.familiaEquipamento`)} />
                            <input type="hidden" {...register(`equipamentos.${index}.grupoProdutoEquipamento`)} />

                            {codigosBloqueados[index] && !isReplica && (
                              <p className="text-red-500 text-xs ms-2">Código Bloqueado! Solicitar liberação VIVO</p>
                            )}
                          </div>
                        ))}
                      </div>

                      {/* div Boleto */}
                      <div className="flex flex-col gap-2 px-4 py-2 bg-gray-50 border rounded-md">
                        <div className="flex flex-row gap-2 w-full">

                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Identificação do Boleto:</label>
                            <input
                              type="text"
                              {...register("idBoleto", { required: true })}
                              onChange={e => {
                                // Permite apenas números
                                const value = e.target.value.replace(/\D/g, '');
                                setValue("idBoleto", value);
                                e.target.value = value;
                              }}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.idBoleto?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.idBoleto?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>                        
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Tipo do Boleto:</label>
                            <select
                              defaultValue="0"
                              {...register("tipoBoleto", { validate: (value) => { return value !== "0";},})}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.tipoBoleto?.type === "validate" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                              `}
                            >
                              <option value="0" disabled>Escolha um tipo</option>
                              {TiposBoleto.map((tipo) => (
                                <option key={tipo.cod} value={tipo.cod}>
                                  {tipo.descricao}
                                </option>
                              ))}
                            </select>
                            {errors?.tipoBoleto?.type === "validate" && (
                              <p className="text-red-500 text-xs ms-2">
                                Tipo é obrigatório
                              </p>
                            )}
                          </div>
                          
                        </div>

                        <div className="flex flex-row gap-2 w-full">

                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Tipo de Planta:</label>
                            <select
                              defaultValue="0"
                              {...register("tipoPlanta", {
                                validate: (value) => { return value !== "0"; },
                                onChange: (e) => { handleTipoAtendimento(e) },
                              })
                              }
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${errors?.tipoPlanta?.type === "validate" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                                `}
                            >
                              <option value="0" disabled>Escolha um tipo</option>
                              {TiposPlanta.map((tipo) => (
                                <option key={tipo.cod} value={tipo.cod}>
                                  {tipo.descricao}
                                </option>
                              ))}
                            </select>
                            {errors?.tipoPlanta?.type === "validate" && (
                              <p className="text-red-500 text-xs ms-2">
                                Tipo Planta é obrigatório
                              </p>
                            )}
                          </div>

                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Tipo de Atendimento:</label>
                            <select
                              {...register("tipoAtendimento", {
                                required: true,
                                onChange: (e) => handleTipoAtendimento(e)
                              })}
                              className="block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                            >
                              <option value="" disabled hidden>Selecione o tipo de atendimento</option>
                              {tiposAtendimentoFiltrados.map(tipo => (
                                <option key={tipo.cod} value={tipo.cod}>
                                  {tipo.descricao}
                                </option>
                              ))}
                            </select>
                            {errors?.tipoAtendimento?.type === "validate" && (
                              <p className="text-red-500 text-xs ms-2">
                                Tipo é obrigatório
                              </p>
                            )}
                          </div>

                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">
                              Programar para:
                            </label>
                            <input
                              {...register("dataHoraProgramado", {
                                required: isProgramado ? true : false,
                                validate: isProgramado
                                  ? (value) => {
                                      if (!value) return true; // required já cobre vazio
                                      const selected = moment.tz(value, 'America/Sao_Paulo');
                                      const minAllowed = moment().tz('America/Sao_Paulo').add(1, 'day').startOf('day');
                                      return selected.isSameOrAfter(minAllowed) || 'Programar apenas a partir do dia seguinte (D+1).';
                                    }
                                  : undefined,
                              })}
                              disabled={!isProgramado ? true : false}
                              min={minDateProgramado}
                              type="datetime-local"
                              placeholder="Start Date and Time"
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${errors?.dataHoraProgramado
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {isProgramado && (
                              <p className="text-red-500 text-xs ms-2">
                                *Agendar entre 9h e 17h
                              </p>
                            )}
                            {errors?.dataHoraProgramado?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                            {errors?.dataHoraProgramado?.type === "validate" && (
                              <p className="text-red-500 text-xs ms-2">
                                {errors.dataHoraProgramado.message}
                              </p>
                            )}
                          </div>

                        </div>
                      </div>

                      {/* div Site */}
                      <div className="flex flex-col gap-2 px-4 py-2 bg-gray-50 border rounded-md relative">
                      <div className="absolute right-4 top-2 text-blue-400 font-bold"><a href="#">Ver mais</a></div>

                        <div className="flex flex-row gap-2 w-full">
                          
                          <div className="flex flex-col items-start gap-1 w-1/4">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Site:</label>
                            <input
                              // disabled={true}
                              type="text"
                              style={{ textTransform: 'uppercase' }}
                              {...register("site", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.site?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.site?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>

                          {/* <div className="flex flex-col items-start gap-1 w-full">
                              <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                                GMO:
                              </label>
                              <select
                                defaultValue="0"
                                {...register("gmo", {
                                  onChange: (e) => {handleOnGmoChange(e)},
                                  validate: (value) => {
                                    return value !== "0";
                                  },
                                })}
                                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                  ${
                                    errors?.gmo?.type === "validate"
                                      ? " border border-red-500 outline-none ring-0"
                                      : "border border-zinc-500 outline-none ring-0"
                                  }
                                  `}
                              >
                                <option value="0" disabled>
                                  Escolha um GMO
                                </option>
                                {gmoList.gmos.map((gmo) => (
                                  <option key={gmo._id} value={gmo._id}>
                                    {gmo.cidade === "SÃO PAULO"
                                      ? `SP - ${gmo.identificador} - ${gmo.endereco}`
                                      : `${gmo.cidade} - ${gmo.endereco}`}
                                  </option>
                                ))}
                              </select>
                              {errors?.gmo?.type === "validate" && (
                                <p className="text-red-500 text-xs whitespace-nowrap">
                                  GMO é obrigatório
                                </p>
                              )}
                          </div> */}
                          <div className="flex flex-col items-start gap-1 w-full relative">
                            <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                              GMO:
                            </label>
                            <input
                              type="text"
                              value={gmoSearchTerm}
                              placeholder="...digite ao menos 3 caracteres para buscar"
                              onChange={handleGmoInputChange}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
      ${errors?.gmo?.type === "validate"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                                }
    `}
                              autoComplete="off"
                              onFocus={() => { if (gmoSearchTerm.length >= 3) setShowGmoList(true); }}
                              name="gmo_search"
                              disabled={gmoDisabled}
                            />
                            {gmoSearchTerm.length > 0 && gmoSearchTerm.length < 3 && (
                              <div className="ms-2 text-gray-400 italic flex gap-1 justify-center items-center">
                                <CiCircleInfo />
                                digite ao menos 3 caracteres para buscar
                              </div>
                            )}
                            {gmoSearchResults.length > 0 && showGmoList && (
                              <div className="absolute w-full top-full left-0 mt-1 max-h-52 overflow-y-auto bg-white rounded shadow-lg border border-gray-200 z-20">
                                <ul>
                                  {gmoSearchResults.map((gmo) => (
                                    <li
                                      key={gmo._id}
                                      onClick={() => handleSelectGmo(gmo)}
                                      className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                    >
                                      {gmo.cidade === "SÃO PAULO"
                                        ? `SP - ${gmo.identificador} - ${gmo.endereco}`
                                        : gmo.isBbn === true
                                        ? `BBN - ${gmo.identificador} - ${gmo.endereco} - ${gmo.cidade}/${gmo.uf}`
                                        : `${gmo.cidade} - ${gmo.endereco}`}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                            {/* Campo hidden para manter integração com react-hook-form */}
                            <input
                              type="hidden"
                              {...register("gmo", {
                                validate: (value) => value && value !== "0",
                              })}
                            />
                            {errors?.gmo?.type === "validate" && (
                              <p className="text-red-500 text-xs whitespace-nowrap">
                                GMO é obrigatório
                              </p>
                            )}
                          </div>

                        </div>

                        <div className="flex flex-row gap-2 w-full">
                          <div className="flex flex-col items-start gap-1 w-1/2">
                              <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                                DRS Origem:
                              </label>
                              <select
                                disabled={true}
                                defaultValue="0"
                                {...register("drsOriginal", {
                                  validate: (value) => {
                                    return value !== "0";
                                  },
                                })}
                                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                  ${
                                    errors?.drsOriginal?.type === "validate"
                                      ? " border border-red-500 outline-none ring-0"
                                      : "border border-zinc-500 outline-none ring-0"
                                  }
                                  `}
                              >
                                <option value="0" disabled>
                                  Escolha um depósito de origem
                                </option>
                                {depositList?.deposits?.map((deposit) => (
                                    <option key={deposit._id} value={deposit._id}>
                                        {deposit.cidade} - {deposit.sigla}
                                    </option>
                                ))}
                              </select>
                              {errors?.drsOriginal?.type === "validate" && (
                                <p className="text-red-500 text-xs whitespace-nowrap">
                                  Depósito a atender é obrigatório
                                </p>
                              )}
                            </div>
                            

                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Endereço DRS:</label>
                            <input
                              disabled={true}
                              type="text"
                              {...register("enderecoDepostio", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.enderecoDepostio?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.enderecoDepostio?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>
                        </div>
                        
                      </div>

                      {/* div Contato */}
                      <div className="flex flex-col gap-2 px-4 py-2 bg-gray-50 border rounded-md">
                        <div className="flex flex-row gap-2 w-full">
                          <div className="flex flex-col items-start gap-1 w-2/3">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">RE Técnico:</label>
                            <div className="flex gap-2 w-full">
                              <input
                                disabled={user.role === 'tecnico'}
                                type="text"
                                {...register("reTecnico", { required: true })}
                                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
        ${errors?.reTecnico?.type === "required"
                                    ? " border border-red-500 outline-none ring-0"
                                    : "border border-zinc-500 outline-none ring-0"
                                  }
      `}
                              />
                              <button
                                type="button"
                                onClick={async () => {
                                  const reTecnico = getValues("reTecnico"); // Obtém o valor do campo RE Técnico
                                  if (!reTecnico) {
                                    alert("Por favor, preencha o campo RE Técnico antes de buscar.");
                                    return;
                                  }

                                  try {
                                    const response = await SgsService.getTecnico(reTecnico);
                                    if (response?.result?.data) {
                                      const tecnico = response.result.data;
                                      setValue("tecnico", tecnico.nome); // Preenche o campo 'tecnico' com o nome
                                      setValue("telefone", tecnico.telefone); // Preenche o campo 'telefone' com o telefone
                                      // Apenas para usuários com role 'user': se o backend identificou
                                      // o User pela matrícula, pré-seleciona a empresa do técnico no
                                      // dropdown. Para outras roles, mantém o valor já definido
                                      // (por padrão a empresa do próprio usuário logado).
                                      if (response.empresaId && ehUsuarioInterno(user)) {
                                        setValue("empresaTecnico", response.empresaId);
                                      }
                                      alert("Técnico encontrado e campos preenchidos!");
                                    } else {
                                      alert("Técnico não encontrado.");
                                    }
                                  }catch (error) {
                                    console.error("Erro ao buscar técnico:", error);
                                    alert("Ocorreu um erro ao buscar o técnico.");
                                  }
                                }}
                                className="bg-blue-500 text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
                              >
                                Buscar
                              </button>
                            </div>
                            {errors?.reTecnico?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">Campo obrigatório</p>
                            )}
                          </div>
                          <div className="flex flex-col items-start gap-1 w-2/3">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Técnico:</label>
                            <input
                              disabled={user.role === 'tecnico'}
                              type="text"
                              {...register("tecnico", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.tecnico?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.tecnico?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">
                              Empresa:
                            </label>
                            <div className="w-full">
                              <select
                                disabled={user.role === 'tecnico'}
                                defaultValue="0"
                                {...register("empresaTecnico", {required: true})}
                                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                  ${
                                    errors?.empresaTecnico?.type === "required" ?
                                    " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                  }
                                `}
                              >
                                <option value="0" disabled>Escolha uma empresa</option>
                                {companyList.map((company) => (
                                  <option key={company._id} value={company._id}>
                                    {company.socialName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="flex flex-col items-start gap-1 w-2/3">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Telefone:</label>
                            <input
                              disabled={user.role === 'tecnico'}
                              type="text"
                              {...register("telefone", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.telefone?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.telefone?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="flex flex-row gap-2 w-full">
                          {/* <div className="flex flex-col items-start gap-1 w-2/3">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Endereço Entrega:</label>
                            <input
                              // disabled={true}
                              type="text"
                              {...register("enderecoEntrega", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.enderecoEntrega?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.enderecoEntrega?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div> */}


                          {/* <div className="flex flex-col items-start gap-1 w-2/3">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Endereço Entrega:</label>
                            <select
                              value={selectedEnderecoEntrega}
                              onChange={handleChangeEnderecoEntrega}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
      ${errors?.enderecoEntrega?.type === "required"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                                }
    `}
                              required
                            >
                              <option value="" disabled>
                                Escolha um endereço de entrega
                              </option>
                              {gmoList.gmos.map((gmo) => (
                                <option key={gmo._id} value={gmo._id}>
                                  {gmo.cidade === "SÃO PAULO"
                                    ? `SP - ${gmo.identificador} - ${gmo.endereco}`
                                    : `${gmo.cidade} - ${gmo.endereco}`}
                                </option>
                              ))}
                            </select>
                            {errors?.enderecoEntrega?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div> */}

                          <div className="flex flex-col items-start gap-1 w-2/3 relative">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Endereço Entrega:</label>
                            <input
                              type="text"
                              value={
                                // Se o usuário já digitou algo, mostra o que ele digitou.
                                // Se não digitou nada e existe um endereço selecionado, mostra o endereço selecionado.
                                enderecoEntregaSearchTerm !== ""
                                  ? enderecoEntregaSearchTerm
                                  : (() => {
                                    if (selectedEnderecoEntrega) {
                                      const gmo = gmoList.gmos.find(g => g._id === selectedEnderecoEntrega);
                                      if (!gmo) return "";
                                      return gmo.cidade === "SÃO PAULO"
                                        ? `SP - ${gmo.identificador} - ${gmo.endereco}`
                                        : `${gmo.cidade} - ${gmo.endereco}`;
                                    }
                                    return "";
                                  })()
                              }
                              placeholder="...digite ao menos 3 caracteres para buscar"
                              onChange={e => {
                                setEnderecoEntregaSearchTerm(e.target.value);
                                setShowEnderecoEntregaList(true);
                                if (e.target.value === "") {
                                  // Permite apagar o campo e digitar livremente
                                  setSelectedEnderecoEntrega("");
                                  setValue("enderecoEntrega", "");
                                  setValue("cidadeEntrega", "");
                                }
                                if (e.target.value.length >= 3) {
                                  const filtered = gmoList.gmos.filter(gmo =>
                                    (gmo.cidade + " " + gmo.identificador + " " + gmo.endereco)
                                      .toLowerCase()
                                      .includes(e.target.value.toLowerCase())
                                  );
                                  setEnderecoEntregaSearchResults(filtered);
                                } else {
                                  setEnderecoEntregaSearchResults([]);
                                }
                              }}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
      ${errors?.enderecoEntrega?.type === "required"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                                }
    `}
                              autoComplete="off"
                              onFocus={() => { if (enderecoEntregaSearchTerm.length >= 3) setShowEnderecoEntregaList(true); }}
                              name="enderecoEntrega_search"
                              required
                            />
                            {enderecoEntregaSearchTerm.length > 0 && enderecoEntregaSearchTerm.length < 3 && (
                              <div className="ms-2 text-gray-400 italic flex gap-1 justify-center items-center">
                                <CiCircleInfo />
                                digite ao menos 3 caracteres para buscar
                              </div>
                            )}
                            {enderecoEntregaSearchResults.length > 0 && showEnderecoEntregaList && (
                              <div className="absolute w-full top-full left-0 mt-1 max-h-52 overflow-y-auto bg-white rounded shadow-lg border border-gray-200 z-20">
                                <ul>
                                  {enderecoEntregaSearchResults.map((gmo) => (
                                    <li
                                      key={gmo._id}
                                      onClick={() => {
                                        setSelectedEnderecoEntrega(gmo._id);
                                        setEnderecoEntregaSearchTerm(
                                          gmo.cidade === "SÃO PAULO"
                                            ? `SP - ${gmo.identificador} - ${gmo.endereco}`
                                            : `${gmo.cidade} - ${gmo.endereco}`
                                        );
                                        setShowEnderecoEntregaList(false);
                                        setValue("enderecoEntrega", gmo.endereco);
                                        setValue("cidadeEntrega", gmo.cidade);
                                      }}
                                      className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                    >
                                      {gmo.cidade === "SÃO PAULO"
                                        ? `SP - ${gmo.identificador} - ${gmo.endereco}`
                                        : `${gmo.cidade} - ${gmo.endereco}`}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                            {/* Campo hidden para manter integração com react-hook-form */}
                            <input
                              type="hidden"
                              {...register("enderecoEntrega", { required: true })}
                              value={
                                enderecoEntregaSearchTerm !== ""
                                  ? enderecoEntregaSearchTerm
                                  : (() => {
                                    if (selectedEnderecoEntrega) {
                                      const gmo = gmoList.gmos.find(g => g._id === selectedEnderecoEntrega);
                                      if (!gmo) return "";
                                      return gmo.endereco;
                                    }
                                    return "";
                                  })()
                              }
                            />
                            {errors?.enderecoEntrega?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>


                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Complemento:</label>
                            <input
                              // disabled={true}
                              type="text"
                              {...register("enderecoEntregaComplemento")}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.enderecoEntregaComplemento?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                          </div>
                        </div>
                      </div>

                      {/* div Observação */}
                      <div className="flex flex-col px-4 py-2 bg-gray-50 border rounded-md">
                        <div className="flex flex-row gap-2 w-full">
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Observação:</label>
                            <textarea 
                              {...register("observacao")}
                              className={`
                                  w-full h-[100px] p-4 bg-white rounded-lg border border-zinc-300 justify-start items-center inline-flex resize-none 
                                  text-neutral-600 text-sm font-normal font-['Work Sans']
                                  focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                                  placeholder:text-neutral-400 placeholder:text-sm placeholder:font-normal placeholder:font-['Work Sans'] placeholder:leading-[14.34px]
                              `} 
                              placeholder={"Observação"}></textarea>
                          </div>
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Comentário na Gestão:</label>
                            <textarea 
                              {...register("comentarioGestao")}
                              className={`
                                  w-full h-[100px] p-4 bg-white rounded-lg border border-zinc-300 justify-start items-center inline-flex resize-none 
                                  text-neutral-600 text-sm font-normal font-['Work Sans']
                                  focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                                  placeholder:text-neutral-400 placeholder:text-sm placeholder:font-normal placeholder:font-['Work Sans'] placeholder:leading-[14.34px]
                              `} 
                              placeholder={"Observação Gestão"}></textarea>
                          </div>
                        </div>
                      </div>


                      <button
                        disabled={(hasBlockedCodSap && !isReplica)}
                        onClick={() => handleSubmit(onSubmit)()}
                        className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 disabled:bg-gray-500"
                      >
                        Enviar
                      </button>

                    </div>
                    <label htmlFor=""></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
